export const iconFontAwesomeTextformattingList = (
	<i className="fa-solid fa-list"></i>
);
